import { BaseService } from '../../infra/base.service'
import type { SharePageEntity } from './share-page.entity'
import type { SharePagesRepository } from './share-pages.repository'

export class SharePagesService extends BaseService<SharePageEntity> {
    constructor(private rep: SharePagesRepository) {
        super(rep)
    }

    async publicGetOneByToken(sharePageId: string, token: string) {
        return await this.rep.publicGetOneByToken(sharePageId, token)
    }
}
